export interface EventsUtilsStateInterface {
  value: boolean;
  swearWordsArray: string[];
  regExpSwearWords: RegExp | null;
}

function state(): EventsUtilsStateInterface {
  return {
    value: true,
    swearWordsArray: [],
    regExpSwearWords: null,
  };
}

export default state;
